import { useInfiniteQuery } from 'react-query';
import * as SubscriptionApis from 'apis/subscription';

const SUBSCRIPTION_LIMIT_PER_PAGE = 25;

const getSubscriptions = async ({ page = 0, status }: $TSFixMe) => {
  const {
    data: { subscriptions, count },
  } = await SubscriptionApis.fetchSubscriptions({
    page,
    limit: 25,
    sort: '-created',
    status,
  });
  return { subscriptions, count };
};

const getNextPageParam = (last_page: $TSFixMe, pages: $TSFixMe) =>
  pages.length !== 0 &&
  pages.length < Math.ceil(last_page.count / SUBSCRIPTION_LIMIT_PER_PAGE)
    ? pages.length
    : undefined;

const useInfiniteQuerySubscriptions = ({ status, onError }: $TSFixMe) => {
  const {
    data,
    error,
    fetchNextPage,
    hasNextPage: has_next_page,
    isLoading: is_loading,
    isSuccess: is_success,
    isFetchingNextPage: is_fetching_next_page,
  } = useInfiniteQuery(
    ['getSubscriptions', status],
    ({ pageParam }) => getSubscriptions({ page: pageParam, status }),
    {
      getNextPageParam,
      onError,
    }
  );

  return {
    data,
    error,
    is_loading,
    is_success,
    is_fetching_next_page,
    has_next_page,
    fetchNextPage,
  };
};

export default useInfiniteQuerySubscriptions;
